<!-- TEMPLATE -->
<template>
  <div class="card" v-if="true">
    <div class="card-header">
      <h5 class="card-category">Whois widget</h5>
    </div>
    <div class="card-body">
      <h4 class="card-title" id="whois" v-if="whois.registrar != null">
        <v-icon>mdi-world</v-icon>
        Registered at
        <v-chip>{{ whois.registrar }}</v-chip>
      </h4>
      <h4 class="card-title" id="whois" v-else>
        <v-chip>N/A</v-chip>
      </h4>
    </div>

    <v-expansion-panels :readonly="readonly" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>Whois full response</v-expansion-panel-header>
        <v-expansion-panel-content>
          <vue-json-pretty
            :path="'res'"
            :data="whois"
            :highlightMouseoverNode="1"
          >
          </vue-json-pretty>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<!-- SCRIPT -->
<script>
import VueJsonPretty from "vue-json-pretty";
export default {
  name: "WhoisPlugin",
  data: function () {
    return {};
  },
  created() {},
  methods: {},
  components: {
    VueJsonPretty,
  },
  props: ["whois"],
};
</script>

<!-- Style -->
<style>
</style>